define('shared/util/dispatchers/retrievers/queryPersistence',['shared/util/queryPersistence'], function(queryPersistence ){
    'use strict';

    return function ( key ) {
        return queryPersistence.get(key);
    };
});
